<template>
    <fullscreen-drawer
        v-if="featureFlags['live-site-responsive-design']"
        :visible="visible"
        title="Payout Detail"
        @close="handleClose"
    >
        <payout-details :payout="data" :type="PAYOUT_TYPE_PAYOUT" />
    </fullscreen-drawer>

    <g-drawer v-else :visible="visible" height="100%" get-container="#app" placement="bottom" @close="handleClose">
        <payout-details :payout="data" :type="PAYOUT_TYPE_PAYOUT" />
    </g-drawer>
</template>

<script>
    import PayoutDetails from './PayoutDetails.vue';
    import { PAYOUT_TYPE_PAYOUT } from '../../../../../app-v2/constants/payouts';
    import {useFeatureFlagsStore} from "../../../../../stores";
    import FullscreenDrawer from "../../../../../app-v2/components/library/FullscreenDrawer";

    export default {
        name: 'PaymentDetailsDrawer',

        components: {
            FullscreenDrawer,
            PayoutDetails
        },

        props: {
            visible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: null
            }
        },

        setup(props, context) {
            const featureFlags = useFeatureFlagsStore().data;

            const handleClose = () => {
                context.emit('close');
            };

            return {
                PAYOUT_TYPE_PAYOUT,
                handleClose,
                featureFlags
            };
        }
    };
</script>
